import React, { useState, useRef, useCallback } from 'react';
import { Document, Page } from 'react-pdf';

import { FlexColumn } from 'ui-components/components/flex/column';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './messages';
import { useOnElementWidthChange } from '../../../../../../../../hooks/use-on-element-width-change';
import styles from './template-preview.module.less';
import { useGetPackingSlipPreview } from './use-get-packing-slip-preview';

type TemplatePreviewProps = {
  header: string;
  itemsHeader: string;
  items: string;
  footer: string;
  size: string;
};

export const TemplatePreview = ({ header, itemsHeader, items, footer, size }: TemplatePreviewProps) => {
  const { previewUrl, isLoading, fetchError } = useGetPackingSlipPreview(header, itemsHeader, items, footer, size);
  const containerRef = useRef<HTMLDivElement>(null);
  const [containerWidth, setContainerWidth] = useState<number | null>(null);
  const [hasError, setHasError] = useState(false);

  const handleWidthChange = useCallback((width: number) => {
    if (width) setContainerWidth(width);
  }, []);
  useOnElementWidthChange(containerRef, handleWidthChange);

  const isError = !isLoading && (hasError || fetchError);
  const isPreviewReady = !isLoading && !!previewUrl && !hasError && !fetchError;

  return (
    <div className={styles['preview-container']}>
      <div ref={containerRef} className={styles['pdf-container']}>
        {isLoading && (
          <FlexColumn className={styles['loading-container']}>
            <LoadingIndicator className={styles.loading} />
          </FlexColumn>
        )}
        {isPreviewReady && containerWidth && (
          <Document file={previewUrl} loading={null} onLoadError={() => setHasError(true)} onLoadSuccess={() => setHasError(false)}>
            <Page pageNumber={1} renderAnnotationLayer={false} renderTextLayer={false} width={containerWidth} />
          </Document>
        )}
        {isError && (
          <FlexColumn className={styles['error-container']}>
            <Text textType={TextType.Description} value={messages.loadError} />
          </FlexColumn>
        )}
      </div>
      {isPreviewReady && <Text className={styles['sample-data-note']} textType={TextType.Description} value={messages.sampleDataNote} />}
    </div>
  );
};
